import React from 'react';
import { Orbit, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="relative z-10 bg-[#020308] pt-16 pb-8 border-t border-white/5 mt-20" data-id="element-70">
      {/* Animated gradient line */}
      <div className="absolute top-0 left-0 right-0 h-[1px] animate-nebula-line bg-gradient-to-r from-transparent via-cyan-500 to-transparent" data-id="element-71" />

      <div className="max-w-7xl mx-auto px-6" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-73">
          <div className="md:col-span-2" data-id="element-74">
            <div className="flex items-center gap-2 mb-6" data-id="element-75">
              <Orbit className="w-8 h-8 text-cyan-400" data-id="element-76" />
              <span className="font-display font-bold text-2xl tracking-widest text-white" data-id="element-77">
                NEBULA
              </span>
            </div>
            <p className="text-gray-400 max-w-sm leading-relaxed" data-id="element-78">
              מובילים את המהפכה הבאה בחקר החלל ופיתוח טכנולוגיות חוץ-אטמוספריות.
              העתיד כבר כאן.
            </p>
          </div>

          <div data-id="element-79">
            <h4 className="text-white font-bold mb-6" data-id="element-80">ניווט</h4>
            <ul className="space-y-3" data-id="element-81">
              <li data-id="element-82">
                <a href="#missions" className="text-gray-400 hover:text-cyan-400 transition-colors" data-id="element-83">
                  משימות
                </a>
              </li>
              <li data-id="element-84">
                <a href="#technology" className="text-gray-400 hover:text-cyan-400 transition-colors" data-id="element-85">
                  טכנולוגיה
                </a>
              </li>
              <li data-id="element-86">
                <a href="#fleet" className="text-gray-400 hover:text-cyan-400 transition-colors" data-id="element-87">
                  צי החלליות
                </a>
              </li>
              <li data-id="element-88">
                <a href="#team" className="text-gray-400 hover:text-cyan-400 transition-colors" data-id="element-89">
                  צוות
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-90">
            <h4 className="text-white font-bold mb-6" data-id="element-91">עקבו אחרינו</h4>
            <div className="flex gap-4" data-id="element-92">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white/10 hover:text-cyan-400 transition-all" data-id="element-93">
                <Twitter className="w-5 h-5" data-id="element-94" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white/10 hover:text-cyan-400 transition-all" data-id="element-95">
                <Linkedin className="w-5 h-5" data-id="element-96" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white/10 hover:text-cyan-400 transition-all" data-id="element-97">
                <Github className="w-5 h-5" data-id="element-98" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-99">
          <p className="text-gray-500 text-sm" data-id="element-100">
            © {new Date().getFullYear()} Nebula Aerospace. כל הזכויות שמורות.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-101">
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              תנאי שימוש
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-103">
              פרטיות
            </a>
          </div>
        </div>
      </div>
    </footer>;
}